document.addEventListener("DOMContentLoaded", function () {
  const countdownElement = document.querySelector(".header__timer");
   const timeWrapper = document.querySelector(".header__timer-wrapper");
  const endTimeStr = countdownElement?.dataset.end;

  if (!countdownElement || !endTimeStr) return;

  // Convert end time to timestamp
  const endTime = new Date(endTimeStr).getTime();

  const updateTimer = () => {
    const now = Date.now();
    let diff = Math.floor((endTime - now) / 1000);

    if (diff < 0) {
        diff = 0; // prevent negative countdown
        timeWrapper.style.display = "none";
    }

    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    // Update with split digits
    setSplitDigits("countdown-days", days);
    setSplitDigits("countdown-hours", hours);
    setSplitDigits("countdown-minutes", minutes);
    setSplitDigits("countdown-seconds", seconds);
  };

  // Splits a number into 2 spans (always 2 digits)
  function setSplitDigits(id, value) {
    const element = document.getElementById(id);
    const padded = value.toString().padStart(2, "0");
    element.textContent = padded;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
});
